import { Typography } from 'antd';
import { EllipsisConfig } from 'antd/lib/typography/Base';
import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { BodyShort01, Caption01, SingleLineEllipsis } from 'components/styles';

// TODO: check this style
const Wrapper = styled.div`
  /* display: flex; */
  display: -webkit-box;
  padding: var(--spacing-04) var(--spacing-05);
  height: 48px;
  ${ifProp(
    'onClick',
    css`
      cursor: pointer;
    `,
  )};
`;
const PrimaryRow = styled.div``;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: var(--spacing-03);
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 90%;
  ${BodyShort01};
  ${PrimaryRow} {
    ${SingleLineEllipsis};
    color: var(--gray-100);
  }
`;
const SecondaryRow = styled.div`
  ${Caption01};
  color: var(--gray-70);
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const StatusIndicatorWrapper = styled.span`
  display: flex;
  align-items: center;
  svg {
    width: 18px;
    height: 18px;
  }
`;

export const NameCell: FC<{
  logo: ReactNode;
  primaryText: string | ReactNode;
  secondaryText?: string | ReactNode;
  onClick?: () => void;
  className?: string;
  primaryTextEllipsis?:
    | boolean
    | Omit<EllipsisConfig, 'expandable' | 'rows' | 'onExpand'>;
}> = ({ logo, primaryText, secondaryText, onClick, className }) => {
  const { Text } = Typography;

  return (
    <Wrapper onClick={onClick} className={className}>
      {logo ? <LogoWrapper>{logo}</LogoWrapper> : null}
      <TextWrapper>
        <Text data-cy="timesheet.primary.name">{primaryText}</Text>
        {secondaryText ? <SecondaryRow>{secondaryText}</SecondaryRow> : null}
      </TextWrapper>
    </Wrapper>
  );
};

/**
 * Use it with caution.. Its really really slow
 */
export const NameCellWithTooltip: FC<{
  logo: ReactNode;
  primaryText: string | ReactNode;
  secondaryText?: string | ReactNode;
  onClick?: () => void;
  className?: string;
}> = ({ logo, primaryText, secondaryText, onClick, className }) => {
  const { Text } = Typography;

  return (
    <Wrapper onClick={onClick} className={className}>
      {logo ? <LogoWrapper>{logo}</LogoWrapper> : null}
      <TextWrapper>
        <Text data-cy="timesheet.primary.name" ellipsis={{ tooltip: true }}>
          {primaryText}
        </Text>
        {secondaryText ? <SecondaryRow>{secondaryText}</SecondaryRow> : null}
      </TextWrapper>
    </Wrapper>
  );
};
